import ks from "@shared/kalmstromShared4";
import DBState from "./DBState";
import DBFieldManager from "./DBFieldManager";

export default class DBDragDrop {

    public static Setup = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const fieldItems: NodeListOf<Element> = document.querySelectorAll(".field-type-item");

            const SetupItem = (item: Element): void => {
                const HandleDragStart = (e: Event): void => {
                    const dragEvent: DragEvent = e as DragEvent;
                    const el: HTMLElement = item as HTMLElement;
                    DBState.DraggedType = el.dataset.type || null;
                    el.classList.add("dragging");
                    if (dragEvent.dataTransfer !== null) {
                        dragEvent.dataTransfer.effectAllowed = "copy";
                        dragEvent.dataTransfer.setData("text/plain", el.dataset.type || "");
                    }
                };

                const HandleDragEnd = (): void => {
                    (item as HTMLElement).classList.remove("dragging");
                };

                item.addEventListener("dragstart", HandleDragStart);
                item.addEventListener("dragend", HandleDragEnd);
            };
            fieldItems.forEach(SetupItem);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "DBDragDrop.Setup");
        }
    };

    public static SetupDropZone = (element: Element | null, listId: string): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            if (element === null) { return; }

            const HandleDragOver = (e: Event): void => {
                e.preventDefault();
                const dragEvent: DragEvent = e as DragEvent;
                if (dragEvent.dataTransfer !== null) {
                    dragEvent.dataTransfer.dropEffect = "copy";
                }
                element.classList.add("drag-over");
            };

            const HandleDragLeave = (): void => {
                element.classList.remove("drag-over");
            };

            const HandleDrop = (e: Event): void => {
                e.preventDefault();
                element.classList.remove("drag-over");
                const dragEvent: DragEvent = e as DragEvent;
                let type: string = "";
                if (dragEvent.dataTransfer !== null) {
                    type = dragEvent.dataTransfer.getData("text/plain");
                }
                if (!type) { type = DBState.DraggedType || ""; }
                if (type) {
                    DBFieldManager.OpenAddFieldWithType(listId, type);
                }
            };

            element.addEventListener("dragover", HandleDragOver);
            element.addEventListener("dragleave", HandleDragLeave);
            element.addEventListener("drop", HandleDrop);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "DBDragDrop.SetupDropZone");
        }
    };
}
